import { useCallback, useState } from 'react';

export const DEFAULT_FALLBACK_IMAGE_URL = 'https://cloudinary-res.cloudinary.com/image/upload/v1596199405/dev-console-ui/no-preview.svg';

export const useImgWithFallback = (src: string, fallbackSrc = DEFAULT_FALLBACK_IMAGE_URL) => {
  const [state, setState] = useState<'loading' | 'loaded' | 'error'>('loading');

  const onError = useCallback(() => {
    setState('error');
  }, []);

  const onLoad = useCallback(() => {
    setState('loaded');
  }, []);

  const imgProps = state === 'error' ? { src: fallbackSrc } : { onError, onLoad, src };

  return {
    imgProps,
    state,
  };
};
